<template>
  <div
    class="icon"
    ref="icon"
  >
    <a-modal
      class="del2"
      v-model:visible="visible"
      title="图标"
      :centered="true"
      :getContainer="()=>$refs.icon"
      @ok="handleOk"
      :footer="null"
    >
      <HomeOutlined />
      <SettingFilled />
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import { HomeOutlined, SettingFilled } from '@ant-design/icons-vue';

export default {
  name: "icon",
  components: {
    HomeOutlined,
    SettingFilled,
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    show() {
      this.visible = true
      console.log(2)
    }
  }

};
</script>
<style scoped>
.icon :deep() .anticon {
  margin: 8px;
}
.icon :deep() .anticon svg {
  width: 20px;
  height: 20px;
}
</style>
